import { render, staticRenderFns } from "./ExportPageEdgeTab.vue?vue&type=template&id=bad88838&scoped=true"
import script from "./ExportPageEdgeTab.vue?vue&type=script&lang=js"
export * from "./ExportPageEdgeTab.vue?vue&type=script&lang=js"
import style0 from "./ExportPageEdgeTab.vue?vue&type=style&index=0&id=bad88838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad88838",
  null
  
)

export default component.exports